import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styles from './styles/embed.module.css';
import Chatbot from '@/components/chatbot/Chatbot';
import { Button, Col, Row } from 'antd';
import { CloseOutlined, MessageOutlined } from '@ant-design/icons';
import {
  hidePopupMessage,
  showChatbotWithDelay,
} from '@/store/slices/chatbotVisibility';
import PopupLayout from '@/components/embed/popup-layouts/PopupLayout';
import { motion, AnimatePresence } from 'framer-motion';

const Embed = () => {
  const dispatch = useDispatch();
  const {
    isChatbotVisible,
    animTransition,
    isPopupMessageVisible,
    settings,
    company,
    loading,
  } = useSelector(state => ({
    isChatbotVisible: state.chatbotVisibility.isVisible,
    animTransition: state.chatbotVisibility.animTransition,
    isPopupMessageVisible: state.chatbotVisibility.isPopupMessageVisible,
    settings: state.chatbotDetails.settings,
    company: state.chatbotDetails.company,
    loading: state.chatbotDetails.loading,
  }));

  const buttonVariants = {
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
      },
    },
    hidden: {
      opacity: 0,
      scale: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  const renderPopUpContent = () => {
    const avatar =
      settings.logo || company?.logo || `${process.env.PUBLIC_URL}/icon.png`;
    const message = settings?.popupMessage || null;

    return (
      <PopupLayout
        popupSize={settings?.popupSize || 'MEDIUM'}
        companyName={company?.name}
        headerTitle={settings?.headerTitle}
        position={settings?.position || 'right'}
        visible={isPopupMessageVisible}
        color={settings?.color}
        message={message}
        avatar={avatar}
      />
    );
  };

  const handleClick = e => {
    e.stopPropagation();
    if (isPopupMessageVisible) {
      dispatch(hidePopupMessage());
    } else {
      dispatch(showChatbotWithDelay(5));
    }
  };

  return (
    <Row id="elay-chatbot-wrapper-row" className={styles.wrapper_row}>
      <Col
        id="elay-chatbot-wrapper-col"
        xs={24}
        md={{ span: 11, offset: settings?.position === 'left' ? 0 : 13 }}
        lg={{ span: 8, offset: settings?.position === 'left' ? 0 : 16 }}
        xl={{ span: 7, offset: settings?.position === 'left' ? 0 : 17 }}
        xxl={{ span: 6, offset: settings?.position === 'left' ? 0 : 18 }}
        className={styles.wrapper_col}
      >
        <Chatbot />
        {!isChatbotVisible && renderPopUpContent()}
        <div
          className={
            settings?.position === 'left'
              ? styles.button_wrapper_left
              : styles.button_wrapper
          }
        >
          <AnimatePresence>
            <motion.div
              initial={"hidden"}
              animate={animTransition ? 'hidden' : 'visible'}
              variants={buttonVariants}
            >
              <Button className={styles.open_button}
                style={{ background: settings?.color }}
                loading={loading}
                onClick={handleClick}
                type={loading ? 'link' : 'primary'}
                shape="circle"
                icon={
                  isPopupMessageVisible
                    ? (<CloseOutlined style={{ fontSize: '24px' }} />)
                    : (<MessageOutlined style={{ fontSize: '24px' }} />)
                } />
            </motion.div>
          </AnimatePresence>
        </div>
      </Col>
    </Row>
  );
};

export default Embed;
